// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {RecordingAsset} from './recording-asset.js'
import {RecordingSegment} from './recording-segment.js'

export class CreateRecording {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): CreateRecording {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsCreateRecording(bb: flatbuffers.ByteBuffer, obj?: CreateRecording): CreateRecording {
    return (obj || new CreateRecording()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsCreateRecording(bb: flatbuffers.ByteBuffer, obj?: CreateRecording): CreateRecording {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new CreateRecording()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  recording(obj?: RecordingAsset): RecordingAsset | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new RecordingAsset()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  startTime(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0')
  }

  endTime(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0')
  }

  name(): string | null
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  segmentation(index: number, obj?: RecordingSegment): RecordingSegment | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset
      ? (obj || new RecordingSegment()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 16, this.bb!)
      : null
  }

  segmentationLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  zIndex(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  static startCreateRecording(builder: flatbuffers.Builder) {
    builder.startObject(6)
  }

  static addRecording(builder: flatbuffers.Builder, recordingOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, recordingOffset, 0)
  }

  static addStartTime(builder: flatbuffers.Builder, startTime: bigint) {
    builder.addFieldInt64(1, startTime, BigInt('0'))
  }

  static addEndTime(builder: flatbuffers.Builder, endTime: bigint) {
    builder.addFieldInt64(2, endTime, BigInt('0'))
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, nameOffset, 0)
  }

  static addSegmentation(builder: flatbuffers.Builder, segmentationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, segmentationOffset, 0)
  }

  static startSegmentationVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(16, numElems, 8)
  }

  static addZIndex(builder: flatbuffers.Builder, zIndex: bigint) {
    builder.addFieldInt64(5, zIndex, null)
  }

  static endCreateRecording(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // recording
    return offset
  }

  static createCreateRecording(
    builder: flatbuffers.Builder,
    recordingOffset: flatbuffers.Offset,
    startTime: bigint,
    endTime: bigint,
    nameOffset: flatbuffers.Offset,
    segmentationOffset: flatbuffers.Offset,
    zIndex: bigint | null
  ): flatbuffers.Offset {
    CreateRecording.startCreateRecording(builder)
    CreateRecording.addRecording(builder, recordingOffset)
    CreateRecording.addStartTime(builder, startTime)
    CreateRecording.addEndTime(builder, endTime)
    CreateRecording.addName(builder, nameOffset)
    CreateRecording.addSegmentation(builder, segmentationOffset)
    if (zIndex !== null) CreateRecording.addZIndex(builder, zIndex)
    return CreateRecording.endCreateRecording(builder)
  }
}
